/* prettier-ignore */
import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { isWebViewUserAgent } from '../helpers';

/**
 * Restricts a route to the native WebView. Offline-routes surfaces
 * (`offline-routes`, `offline-hiking/:itemId`) are WebView-only; in a regular
 * browser they are redirected to `/home`. Reads the user-agent synchronously so
 * it is correct on the first navigation and cold-start deep links.
 */
export const webviewOnlyGuard: CanMatchFn = () => {
  if (isWebViewUserAgent())
    return true;

  return inject(Router).parseUrl('/home');
};
